import { render } from "./Pedigree.vue?vue&type=template&id=ee21fc80&scoped=true"
import script from "./Pedigree.vue?vue&type=script&lang=js"
export * from "./Pedigree.vue?vue&type=script&lang=js"

import "./Pedigree.vue?vue&type=style&index=0&id=ee21fc80&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee21fc80"]])

export default __exports__